import { Routes, Route, Navigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { ThemeProvider } from '@/contexts/ThemeContext'
import Navbar from '@components/Navbar'
import Footer from '@components/Footer'
import WhatsAppButton from '@components/WhatsAppButton'
import ScrollToTop from '@components/ScrollToTop'
import Home from '@pages/Home'
import Courses from '@pages/Courses'
import CourseDetail from '@pages/CourseDetail'
import Batches from '@pages/Batches'
import Testimonials from '@pages/Testimonials'
import Contact from '@pages/Contact'
import About from '@pages/About'
import DevOpsRoadmap from '@pages/DevOpsRoadmap'
import AdminDashboard from '@pages/AdminDashboard'
import AdminLogin from '@pages/AdminLogin'
import AdminSetup from '@pages/AdminSetup'
import AdminLeads from '@pages/AdminLeads'
import AdminBatches from '@pages/AdminBatches'
import AdminCourses from '@pages/AdminCourses'
import AdminContacts from '@pages/AdminContacts'
import AdminSettings from '@pages/AdminSettings'
import AdminTestimonials from '@pages/AdminTestimonials'
import AdminProfile from '@pages/AdminProfile'
import AdminServerError from '@pages/AdminServerError'
import NotFound from '@pages/NotFound'
import ApiErrorBanner from '@components/ApiErrorBanner'

import { useLocation } from 'react-router-dom'

function AppInner() {
  const location = useLocation()
  const isAdmin = location.pathname.startsWith('/admin')

  return (
    <div className="min-h-screen bg-white dark:bg-gray-950">
      <ScrollToTop />
      {!isAdmin && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/courses/:slug" element={<CourseDetail />} />
          <Route path="/batches" element={<Batches />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/devops-roadmap" element={<DevOpsRoadmap />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/setup" element={<AdminSetup />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route path="/admin/batches" element={<AdminBatches />} />
          <Route path="/admin/courses" element={<AdminCourses />} />
          <Route path="/admin/contacts" element={<AdminContacts />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="/admin/testimonials" element={<AdminTestimonials />} />
          <Route path="/admin/profile" element={<AdminProfile />} />
          <Route path="/admin/error/500" element={<AdminServerError />} />
          <Route path="/admin/*" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppButton />}
      <ApiErrorBanner />
    </div>
  )
}

function App() {
  return (
    <ThemeProvider>
      <AppInner />
    </ThemeProvider>
  )
}

export default App
